import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tbody", "rowTemplate"];

  connect() {
    console.log("PaymentsController connected");
  }

  addRow(event) {
    event.preventDefault();

    const lastTr = this.tbodyTarget.querySelector("tr.payment-row:last-child");

    let lastEntriedAt = lastTr
      ? lastTr.querySelector("[name='entried_at']")?.value
      : "";

    const today = new Date().toISOString().slice(0, 10);
    const entriedAt = lastEntriedAt || today;

    const template = this.rowTemplateTarget.content.cloneNode(true);
    const newRow = template.querySelector("tr");

    const entriedInput = newRow.querySelector("[name='entried_at']");
    if (entriedInput) entriedInput.value = entriedAt;

    this.tbodyTarget.appendChild(newRow);
    setTimeout(() => {
      newRow.querySelector("[name='client_code']")?.focus();
    }, 50);
  }

  recalculate(event) {
    const tr = event.target.closest("tr");
    if (!tr) return;

    const getVal = (name) =>
      parseInt(tr.querySelector(`[name='${name}']`)?.value || 0);

    const totalAmount =
      getVal("amount") +
      getVal("transfer_fee") +
      getVal("bill_amount") +
      getVal("offset_amount") +
      getVal("bulk_amount");

    tr.querySelector("[name='total_amount']").value = totalAmount;

    const ar = getVal("accounts_receivable");
    tr.querySelector("[name='balance']").value = ar - totalAmount;

    this.recalculateTotals();
    this.calculateColumnTotal(event);
  }

  recalculateTotals() {
    const sum = (selector) =>
      [...this.element.querySelectorAll(selector)].reduce(
        (acc, el) => acc + (parseInt(el.value) || 0),
        0
      );

    document.querySelector("[name='total_total_amounts']").value = sum(
      "[name='total_amount']"
    );
    document.querySelector("#total_balances").value = sum("[name='balance']");
  }

  // === 列方向の合計を再計算 ===
  calculateColumnTotal(event) {
    const type = event.target.name; // 例: "amount" や "transfer_fee"
    if (!type) return;

    // 全行の同名フィールドを合計
    const total = [...this.element.querySelectorAll(`[name='${type}']`)].reduce(
      (acc, el) => acc + (parseInt(el.value) || 0),
      0
    );

    // 合計行のフィールド名: total_amounts, total_transfer_fees 等
    const totalInput = this.element.querySelector(`[name='total_${type}s']`);
    if (totalInput) totalInput.value = total;
  }

  async fetchClientByCode(event) {
    const tr = event.target.closest("tr");
    const code = event.target.value;
    console.log(code);
    if (!code) return;

    const entried_at = tr.querySelector("[name='entried_at']").value;
    const url = `/clients/fetch_by_code?code=${encodeURIComponent(
      code
    )}&entried_at=${encodeURIComponent(entried_at)}`;

    const response = await fetch(url, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const client = await response.json();
    if (client) this.setClientParams(tr, client);
  }

  setClientParams(tr, client) {
    console.log(client);
    tr.dataset.clientId = client.id;
    tr.querySelector("[name='client_code']").value = client.code;
    tr.querySelector("[name='client_name']").value = client.name;
    tr.querySelector("[name='client_payment_condition']").value =
      client.payment_condition;
    tr.querySelector("[name='previous_month_balance_invoice']").value =
      client.previous_month_balance_invoice;
    tr.querySelector("[name='previous_month_total_sales_invoice']").value =
      client.previous_month_total_sales_invoice;
    tr.querySelector("[name='accounts_receivable']").value =
      client.accounts_receivable;

    if (!tr.querySelector("[name='balance']").value) {
      tr.querySelector("[name='balance']").value = client.accounts_receivable;
    }

    this.recalculateTotals();
  }

  async bulkCreate(event) {
    event.preventDefault();
    if (!confirm("入金情報を登録しますか？")) return;

    const payments = [
      ...this.tbodyTarget.querySelectorAll("tr.payment-row")
    ].map((tr) => this.paymentParams(tr));

    if (payments.length === 0) {
      alert("登録対象がありません。");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch("/payments/bulk_create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json"
      },
      body: JSON.stringify({ payments })
    });
    if (response.ok) {
      this.tbodyTarget.innerHTML = "";
      document.querySelectorAll("tfoot input").forEach((el) => (el.value = 0));

      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    } else {
      const errorText = await response.text();
      const alert = document.createElement("div");
      alert.className = "alert alert-danger alert-position text-center";
      alert.innerHTML = `エラー<br>${errorText}`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 5000);
    }
  }

  paymentParams(tr) {
    const get = (name) => tr.querySelector(`[name='${name}']`)?.value || "";
    return {
      client_id: tr.dataset.clientId,
      entried_at: get("entried_at"),
      client_code: get("client_code"),
      client_name: get("client_name"),
      client_payment_condition: get("client_payment_condition"),
      previous_month_balance_invoice: get("previous_month_balance_invoice"),
      previous_month_total_sales_invoice: get(
        "previous_month_total_sales_invoice"
      ),
      accounts_receivable: get("accounts_receivable"),
      amount: get("amount"),
      transfer_fee: get("transfer_fee"),
      bill_amount: get("bill_amount"),
      offset_amount: get("offset_amount"),
      bulk_amount: get("bulk_amount"),
      total_amount: get("total_amount"),
      balance: get("balance"),
      note: get("note")
    };
  }

  handleEnterOnNote(event) {
    if (event.key !== "Enter") return;

    event.preventDefault();

    const tr = event.target.closest("tr");
    if (!tr) return;

    const template = this.rowTemplateTarget.content.cloneNode(true);
    const newRow = template.querySelector("tr");

    const lastEntriedAt = tr.querySelector("[name='entried_at']")?.value;
    const today = new Date().toISOString().slice(0, 10);
    const entriedAt = lastEntriedAt || today;
    newRow.querySelector("[name='entried_at']").value = entriedAt;

    this.tbodyTarget.appendChild(newRow);

    // setTimeout(() => {
    //   newRow.querySelector("[name='client_code']")?.focus();
    // }, 50);
  }
}
